export const GET_REMITTERS = "REMITTER/GET_REMITTERS";
export const GET_REMITTERS_SUCCESS = "REMITTER/GET_REMITTERS_SUCCESS";
export const GET_REMITTERS_FAILURE = "REMITTER/GET_REMITTERS_FAILURE";

export const SET_FITER_PARAMS = "REMITTER/SET_FITER_PARAMS";

export const GET_RECOVERY_PASSWORD_LINK = "REMITTER/GET_RECOVERY_PASSWORD_LINK";

export const GET_RECOVERY_PASSWORD_LINK_SUCCESS =
  "REMITTER/GET_RECOVERY_PASSWORD_LINK_SUCCESS";
export const GET_RECOVERY_PASSWORD_LINK_FAILURE =
  "REMITTER/GET_RECOVERY_PASSWORD_LINK_FAILURE";
